import React from 'react';
import * as S from './ReviewCard.styles';
import TravellerDetailCard from '../TrvellerDetailCard/TravellerDetail';
import { ITRAVELLER_BLOCK, ITRAVELLER_BLOCK_SEAT } from './../../../../containers/Review/Validation';

const TravellerBlock = (props: ITRAVELLER_BLOCK) => {
  const { seatsSelected, travellerInfo, onChange, onGenderChange, pax_prefill, onPaxSelect } = props;

  return (
    <S.TabContentInner>
      {seatsSelected && seatsSelected.map(function (seatObj: ITRAVELLER_BLOCK_SEAT, index: number) {
        const { f_fseat, lseat, seat, f_mseat, mseat, s_type } = seatObj;
        return (<TravellerDetailCard key={`p${index + 1}`}
          headerId={`p${index + 1}`}
          travellerNumber={index + 1}
          travellerInfo={travellerInfo[index]}
          onChange={onChange}
          onGenderChange={onGenderChange}
          pax_prefill={pax_prefill}
          onPaxSelect={onPaxSelect}
          genderType={(function () {
            let type = ""
            if (f_fseat || lseat == 'true') {
              type = "femaleOnly"
            } else if (f_mseat) {
              type = "maleOnly"
            }
            return type;

          })()}
          seatNumber={seat}
          seatType={(function () {
            let name = getBusIconName(seatObj)
            return name;
          })()}
          passengerType=
          {(function () {
            let name = ""
            if (!index) {
              name = "Primary Passenger";
            } else {
              if (f_fseat) {
                name = "Ladies Only";
              }
              else if (lseat == 'true') {
                name = "Ladies";
              } else if (f_mseat) {
                name = "Male Only";
              }
            }
            return name;
          })()}
        />)
      })}
    </S.TabContentInner>
  )
}

export default TravellerBlock;

const getBusIconName = (seat) => {
  const { f_fseat, lseat, f_mseat, st } = seat
  if (!st) {
    return "";
  }
  let name = ""
  const seater = (st && st.toLowerCase().indexOf('seater') !== -1)
  if (f_fseat || lseat == 'true') {
    name = seater ? "BusSeatLadiesIcon" : "BusSleeperLadiesIcon";
    return name;
  } else if (f_mseat) {
    name = seater ? "BusSeatMenIcon" : "BusSleeperMenIcon";
    return name;
  }
  return seater ? "BusSeatIcon" : "BusSleeperIcon";
}
